import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import { DataTableItemAction, DataTableCell, DataTableItem } from './index';

export interface DataTableRowProps {
  ColumnWidths?: number[];
  DeleteItem?: (Id: string) => void;
  Item: DataTableItem;
  ItemActions?: (Id: string) => DataTableItemAction[];
  OpenInNewWindow?: boolean;
  HideDeleteButton?: boolean;
}

const DataTableRow = ({
  ColumnWidths = null,
  DeleteItem = null,
  Item,
  ItemActions = null,
  OpenInNewWindow,
  HideDeleteButton = false,
}: DataTableRowProps) => {
  const showActionsMenu =
    Item.ItemId &&
    Item.ItemId !== null &&
    ((DeleteItem != null && DeleteItem !== undefined) ||
      (ItemActions !== null && ItemActions !== undefined));
  const generateKey = (pre: string, index: number) => {
    const formattedPre = pre
      ? encodeURIComponent(pre.substring(0, 20))
      : encodeURIComponent(new Date().toString());
    return `${formattedPre}_${index}`;
  };

  const handleActionClick = (Action: (Id: string) => void) => {
    Action(Item.ItemId);
  };

  const handleDeleteClick = (Id: string) => {
    DeleteItem(Id);
  };

  return (
    <tr className="datatable-row">
      {Item.Items !== null &&
        Item.Items.length > 0 &&
        Item.Items.map((item, index) => (
          <DataTableCell
            key={generateKey(item, index)}
            Text={item}
            Url={Item.Url}
            Width={
              ColumnWidths &&
              ColumnWidths !== undefined &&
              ColumnWidths[index] !== null
                ? ColumnWidths[index]
                : null
            }
            OpenInNewWindow={OpenInNewWindow}
          />
        ))}
      {showActionsMenu && (
        <td className="table-data-td-actions p-0" width={100}>
          <Dropdown className="">
            <Dropdown.Toggle
              variant="link"
              id={`dropdown-${Item.ItemId}`}
              className="table-data-btn-actions w-100"
            >
              <Icon AriaLabel="Toiminnot" Name="three-dots-vertical" />
            </Dropdown.Toggle>
            <Dropdown.Menu
              renderOnMount
              popperConfig={{ strategy: 'fixed' }}
              className="bg-white"
            >
              {ItemActions !== null &&
                ItemActions !== undefined &&
                ItemActions.length > 0 &&
                ItemActions(Item.ItemId).map(action => (
                  <Dropdown.Item
                    key={encodeURI(action.ButtonText)}
                    onClick={() => handleActionClick(action.ButtonAction)}
                  >
                    {action.ButtonText}
                  </Dropdown.Item>
                ))}
              {!HideDeleteButton && DeleteItem !== undefined && (
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => handleDeleteClick(Item.ItemId)}
                >
                  Poista
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </td>
      )}
    </tr>
  );
};

// DataTableRow.defaultProps = {
//   ColumnWidths: null,
//   DeleteItem: null,
//   ItemActions: null,
// };

export default DataTableRow;
export { DataTableRow };
